/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ at: NonNullable<unknown> }} Property_Ai_Catalog_Generated_AtInputs */

const cs_property_ai_catalog_generated_at = /** @type {(inputs: Property_Ai_Catalog_Generated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vygenerováno ${i?.at}`)
};

const en_property_ai_catalog_generated_at = /** @type {(inputs: Property_Ai_Catalog_Generated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generated ${i?.at}`)
};

/**
* | output |
* | --- |
* | "Generated {at}" |
*
* @param {Property_Ai_Catalog_Generated_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_generated_at = /** @type {((inputs: Property_Ai_Catalog_Generated_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_Generated_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_generated_at(inputs)
	return cs_property_ai_catalog_generated_at(inputs)
});